import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

class GoogleMap extends Component {
    main;
    markerBounds = null;

    constructor(props) {
        super(props);
        this.defaultCenter = props.defaultCenter
        this.defaultZoom = props.defaultZoom
    }

    getMarkerBounds() {
        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLong = Infinity;
        let maxLong = -Infinity;
        let bounds = {};

        _.each(this.props.markers, marker => {
            const { lat, lng } = marker;
            if (lat < minLat) {
                minLat = lat;
            }
            if (lat > maxLat) {
                maxLat = lat;
            }
            if (lng < minLong) {
                minLong = lng;
            }
            if (lng > maxLong) {
                maxLong = lng;
            }
        });

        this.markerBounds = {
            west: minLong,
            east: maxLong,
            north: minLat,
            south: maxLat
        };
    }

    handleApiLoaded(map) {
        if (this.props.fitToMarkerBounds && !this.markerBounds) {
            this.getMarkerBounds();
        }

        map.fitBounds(this.markerBounds);
    }

    render() {
        const { props, state } = this;
        return (
            <div id={this.props.id} className="is-google-map" ref={main => (this.main = main)}>
                <GoogleMapReact
                    style={props.style}
                    defaultCenter={this.defaultCenter}
                    defaultZoom={this.defaultZoom}
                    center={props.defaultCenter}
                    zoom={props.defaultZoom}
                    markers={props.markers}
                    options={props.options}
                    bootstrapURLKeys={{
                        key: props.apiKey,
                        language: props.lang || `en`
                    }}
                //yesIWantToUseGoogleMapApiInternals={true}
                //onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map)}
                >
                    {props.children}
                </GoogleMapReact>
            </div>
        );
    }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/GoogleMap.js